export default __webpack_public_path__ + "static/media/resetIcon.6401523b.svg";